import { faTable } from "@fortawesome/free-solid-svg-icons";

import SponsorshipList from "./pages/SponsorshipList";
import SponsorshipDetails from "./pages/SponsorshipDetails";

// The path is what the notification email links to, so it can't be renamed
// without changing sponsorFormSubmission.ts in the API.
export const sponsorshipsRoutes = [
  {
    path: "/sponsorships",
    breadcrumb: "Sponsorships",
    component: SponsorshipList,
  },
  {
    path: "/sponsorships/:id",
    breadcrumb: "Enquiry Details",
    component: SponsorshipDetails,
  },
];

export const sponsorshipsSidebarRoutes = [
  {
    path: "/sponsorships",
    label: "Sponsorships",
    icon: faTable,
  },
];
